import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dreamy%20ethereal%20abstract%20scene%20with%20soft%20flowing%20sound%20waves%20visualized%20as%20gentle%20curves%20in%20warm%20cream%20and%20beige%20tones%2C%20floating%20particles%20like%20musical%20notes%2C%20soft%20ambient%20glow%2C%20minimalist%20and%20artistic%20composition%2C%20peaceful%20atmosphere%2C%20no%20text%2C%20abstract%20audio%20visualization%20aesthetic&width=1800&height=900&seq=hero-ersao-main&orientation=landscape"
        alt="耳骚 - 极致听觉体验"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-4">
            让耳朵<span className="text-primary-300">沉迷</span>其中
            <br />
            无法自拔
          </h1>
          <p className="text-sm md:text-lg text-background-200/90 max-w-xl mx-auto mb-8 leading-relaxed">
            ASMR音频 · 沉浸式声景 · 高品质耳机推荐
            <br />
            满足你对声音的深层渴望，开启极致听觉之旅
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/asmr-audio"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              开始探索
            </Link>
            <Link
              to="/category/immersive-soundscape"
              className="px-8 py-3 border border-background-200/60 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              沉浸声景
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}